import React from 'react';
import {
    Grid,
    TextField,
    Autocomplete
} from '@mui/material';

interface NPIRoleMappingStepProps {
    values: any;
    npiRolesFromClient: any[];
    handleTargetNPIRoleChange: (setFieldValue: any, index: number, obj: any) => void;
    handleNewNPIRoleChange: (setFieldValue: any, index: number, val: string) => void;
    touched: any;
    errors: any;
    getNPIRoleHelperText: (touched: any, key: string, index: number) => any;
    getNPIRoleError: (errors: any, key: string, index: number) => any;
    setFieldValue: (field: string, value: any) => void;
    handleBlur: (e: any) => void;
    classes: any;
}

const NPIRoleMappingStep: React.FC<NPIRoleMappingStepProps> = ({
    values,
    npiRolesFromClient,
    handleTargetNPIRoleChange,
    handleNewNPIRoleChange,
    touched,
    errors,
    getNPIRoleHelperText,
    getNPIRoleError,
    setFieldValue,
    handleBlur,
    classes
}) => {
    return (
        <>
            {values.npiRoleMapping?.map((role, index) => (
                <Grid container className='pb-4 align-items-start' key={index} sx={{ borderBottom: '1px solid #f0f0f0', pt: 2, px: 1 }}>
                    <Grid item xs={4} className='pr-3'>
                        <Grid className={classes.w90}>
                            <div><b>{`${role.sourceNpiRoleId} - ${role.sourceNpiRoleName}`}</b></div>
                        </Grid>
                    </Grid>
                    <Grid item xs={4}>
                        <Autocomplete
                            onChange={(e, value) => handleTargetNPIRoleChange(setFieldValue, index, value)}
                            className={classes.w90}
                            value={role.targetNpiRoleId}
                            options={[{ id: 0, name: 'Copy Provider Role' }, ...npiRolesFromClient]}
                            getOptionLabel={(option) => option.name || ''}
                            isOptionEqualToValue={(option, value) => value.name === option.name}
                            renderInput={params => (
                                <TextField {...params} label="Target Provider Role *" fullWidth />
                            )}
                            disableClearable
                        />
                    </Grid>
                    <Grid item xs={4}>
                        {role.targetNpiRoleId.id === 0 && (
                            <TextField
                                sx={{ mt: 4 }}
                                required
                                label="New Provider Role Name"
                                name={`npiRoleMapping.${index}.newNpiRoleName`}
                                className={classes.w90}
                                value={role.newNpiRoleName}
                                onBlur={handleBlur}
                                onChange={e => handleNewNPIRoleChange(setFieldValue, index, e.target.value)}
                                helperText={getNPIRoleHelperText(touched, 'newNpiRoleName', index) && getNPIRoleError(errors, 'newNpiRoleName', index)}
                                error={Boolean(getNPIRoleHelperText(touched, 'newNpiRoleName', index) && getNPIRoleError(errors, 'newNpiRoleName', index))}
                            />
                        )}
                    </Grid>
                </Grid>
            ))}
        </>
    );
};

export default NPIRoleMappingStep;
